/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse text & lines`)
};

const es_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invierte texto y líneas`)
};

const de_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text & Zeilen umkehren`)
};

const nl_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst en lijnen omdraaien`)
};

const fr_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverser le texte et les lignes`)
};

const it_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverti testo e righe`)
};

const pt_br2_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverta texto e linhas`)
};

const pt_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverta texto e linhas`)
};

const ja_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストと行を反転`)
};

const zh_rv_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反转文本和行`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_nav_main_desc", locale)
	if (locale === "en") return en_rv_nav_main_desc(inputs)
	if (locale === "es") return es_rv_nav_main_desc(inputs)
	if (locale === "de") return de_rv_nav_main_desc(inputs)
	if (locale === "nl") return nl_rv_nav_main_desc(inputs)
	if (locale === "fr") return fr_rv_nav_main_desc(inputs)
	if (locale === "it") return it_rv_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_rv_nav_main_desc(inputs)
	if (locale === "pt") return pt_rv_nav_main_desc(inputs)
	if (locale === "ja") return ja_rv_nav_main_desc(inputs)
	return zh_rv_nav_main_desc(inputs)
};